/* eslint-disable max-len */
import { PlayerListItem } from 'types/player';
import { RootState } from 'store';

export const selectPlayers = (state: RootState): PlayerListItem[] | null => state.search.players;

export const selectSearchIsLoading = (state: RootState): boolean => state.search.isLoading;

export const selectSearchIsLoadingAdvancedSearch = (state: RootState): boolean => state.search.isLoadingAdvancedSearch;
